import { HomeworkCardEdit } from './HomeworkCardEdit';
export default HomeworkCardEdit;
